import React from 'react';
import { DashboardOverviewSkeleton } from './DashboardSkeleton';
import { IdealProfilesPageSkeleton } from './IdealProfilesPageSkeleton';
import { OrgChartSkeleton } from './OrgChartSkeleton';
import { CompanyManagementSkeleton } from './CompanyManagementSkeleton';
import { TableSkeleton } from './TableSkeleton';
import { AssessmentSkeleton } from './AssessmentSkeleton';
import { TrainingContentSkeleton, TrainingPublicSkeleton } from './TrainingSkeleton';
import { M3RegisterSkeleton, M3InstructionsSkeleton, M3AssessmentMainSkeleton } from './M3Skeleton';

interface RouteSkeletonProps {
  route?: string;
}

export const RouteSkeleton: React.FC<RouteSkeletonProps> = ({ route }) => {
  // Map routes to appropriate skeletons
  const skeletonMap: Record<string, React.ReactNode> = {
    '/dashboard': <DashboardOverviewSkeleton />,
    '/admin': <DashboardOverviewSkeleton />,
    '/assessment': <AssessmentSkeleton />,
    '/behavioral-assessment': <AssessmentSkeleton />,
    '/ideal': <IdealProfilesPageSkeleton />,
    '/profiles': <IdealProfilesPageSkeleton />,
    '/ideal-profiles': <IdealProfilesPageSkeleton />,
    '/org': <OrgChartSkeleton />,
    '/company': <CompanyManagementSkeleton />,
    '/company-management': <CompanyManagementSkeleton />,
    '/talent': <TableSkeleton />,
    '/management': <TableSkeleton />,
    '/work': <TableSkeleton />,
    '/work-behavior-admin': <TableSkeleton />,
    '/my-results': <TableSkeleton />,
    '/training': <TrainingContentSkeleton />,
    '/training-public': <TrainingPublicSkeleton />,
    '/m3-register': <M3RegisterSkeleton />,
    '/model3': <M3AssessmentMainSkeleton />,
  };

  if (route && skeletonMap[route]) {
    return <>{skeletonMap[route]}</>;
  }

  // Default skeleton
  return <DashboardOverviewSkeleton />;
};
